<div class="contextmenu" [ngStyle]="{ 'left.px': positionX, 'top.px': positionY }" data-cy="file-manager-context-menu">
  <div data-cy="file-manager-context-close-container">
    <div class="context-button close-button"
         (click)="closeContext()"
         data-cy="file-manager-context-close-button">
      <i class="material-icons close-icon" data-cy="file-manager-context-close-icon">close</i>
    </div>
  </div>
  <div data-cy="file-manager-context-upload-container">
    <button mat-button color="primary"
            class="context-button"
            (click)="emitUpload()"
            data-cy="file-manager-context-upload-button">
      Upload an image
    </button>
  </div>
</div>
